module.exports = __webpack_public_path__ + "assets/img/main-type-3.86c40103.svg";